var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSpin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1403_13830)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.4791 50.1152C45.4791 49.5497 45.3966 48.706 44.942 47.8218C44.0944 46.1762 42.7186 45.877 41.697 44.3735C41.2514 43.7183 40.7698 42.6815 40.7698 41.0928H30.7468C30.7468 42.683 30.2652 43.7183 29.8197 44.3735C28.7965 45.8785 27.4223 46.1777 26.5747 47.8218C26.1186 48.706 26.0376 49.5497 26.0376 50.1152C29.1611 50.193 42.3571 50.193 45.4806 50.1152H45.4791Z",
    fill: "#F3B91A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4078 51.9999H25.1045V50.3917C25.1045 50.1299 25.3175 49.9175 25.5801 49.9175H45.9307C46.1932 49.9175 46.4063 50.1299 46.4063 50.3917V51.9999H46.4078Z",
    fill: "#F3B91A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.157 49.9176C28.651 49.8727 32.1466 49.8847 35.6421 49.8667C39.1376 49.8847 42.6317 49.8742 46.1272 49.9176C42.6317 49.9624 39.1376 49.9505 35.6421 49.9684C32.1481 49.9505 28.6525 49.9609 25.157 49.9176Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M43.0383 45.8242H28.6196C27.9205 46.3942 27.2214 46.8939 26.7128 47.8812C26.2597 48.7594 26.1787 49.5972 26.1787 50.1582C29.2797 50.236 42.3782 50.236 45.4777 50.1582C45.4777 49.5972 45.3966 48.7594 44.9436 47.8812C44.435 46.8939 43.7344 46.3957 43.0368 45.8242H43.0383Z",
    fill: "url(#paint0_linear_1403_13830)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7511 38.5326C54.9082 34.3991 56.9875 28.9806 56.9875 23.562H35.6963L50.7511 38.5326Z",
    fill: "#8FC275"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9875 23.5619C56.9875 18.1434 54.9082 12.7248 50.7511 8.59131L35.6963 23.5619H56.9875Z",
    fill: "#20B2E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6946 44.7336C41.1434 44.7336 46.5922 42.6661 50.7494 38.5326L35.6946 23.562V44.7336Z",
    fill: "#F8C92A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6399 38.5326C24.797 42.6676 30.2459 44.7336 35.6947 44.7336V23.562L20.6399 38.5326Z",
    fill: "#F3954E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6946 23.562H14.4033C14.4033 28.9806 16.4826 34.3991 20.6398 38.5326L35.6946 23.562Z",
    fill: "#F1616F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7511 8.58965C46.594 4.45467 41.1451 2.38867 35.6963 2.38867V23.5603L50.7511 8.58965Z",
    fill: "#397BBF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6398 8.59131C16.4826 12.7263 14.4033 18.1434 14.4033 23.5619H35.6946L20.6383 8.59131H20.6398Z",
    fill: "#9A4C66"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6947 2.38867C30.2459 2.38867 24.797 4.45617 20.6399 8.58965L35.6947 23.5603V2.38867Z",
    fill: "#4254A4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M49.6875 37.3506C57.461 29.5989 57.461 17.031 49.6875 9.27928C41.914 1.52759 29.3106 1.52759 21.5371 9.27928C13.7636 17.031 13.7636 29.5989 21.5371 37.3506C29.3106 45.1023 41.914 45.1023 49.6875 37.3506Z",
    fill: "url(#paint1_radial_1403_13830)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.5417 6.84842C44.3346 6.84842 51.9317 11.9064 55.5698 19.2534C53.6315 10.0215 45.4012 3.08594 35.5417 3.08594C25.6822 3.08594 17.4535 10.0215 15.5137 19.2534C19.1517 11.9064 26.7489 6.84692 35.5417 6.84692V6.84842Z",
    fill: "#010101"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7155 43.4187C24.6333 43.4187 15.6184 34.4531 15.6184 23.4335C15.6184 12.4138 24.6333 3.44971 35.7155 3.44971C46.7977 3.44971 55.8126 12.4153 55.8126 23.435C55.8126 34.4546 46.7977 43.4202 35.7155 43.4202V43.4187ZM35.7155 4.59416C25.2694 4.59416 16.7691 13.0451 16.7691 23.4335C16.7691 33.8218 25.2694 42.2728 35.7155 42.2728C46.1616 42.2728 54.6619 33.8218 54.6619 23.4335C54.6619 13.0451 46.1616 4.59416 35.7155 4.59416Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4007 23.5743L33.2762 23.5638L16.3101 22.1426V25.006L33.2762 23.5847L33.4007 23.5743Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0291 23.5743L38.1551 23.5847L55.1212 25.006V22.1426L38.1551 23.5638L38.0291 23.5743Z",
    fill: "#F2F2F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7036 21.1489L35.7141 21.2731L35.7246 21.1489L37.1543 4.27832H34.2754L35.7036 21.1489Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7156 25.875L35.7051 25.9992L34.2769 42.8697H37.1558L35.7261 25.9992L35.7156 25.875Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9514 21.8208L33.8703 21.7251L22.8842 8.79053L21.8745 9.79585L21.8595 9.81081L20.8499 10.8161L33.8568 21.74L33.9529 21.8208H33.9514Z",
    fill: "#F2F2F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4783 25.3271L37.5593 25.4229L48.5455 38.3574L49.5552 37.3521L49.5702 37.3372L50.5798 36.3318L37.5728 25.4079L37.4768 25.3271H37.4783Z",
    fill: "#F2F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4785 21.8208L37.5745 21.74L50.5815 10.8161L49.5719 9.81081L49.5569 9.79585L48.5472 8.79053L37.561 21.7251L37.48 21.8208H37.4785Z",
    fill: "#F2F2F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9514 25.3271L33.8554 25.4079L20.8484 36.3318L21.858 37.3372L21.873 37.3521L22.8827 38.3574L33.8689 25.4229L33.9499 25.3271H33.9514Z",
    fill: "#F2F2F2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6946 47.123C22.6291 47.123 12 36.5536 12 23.5622C12 10.5708 22.6306 0 35.6946 0C48.7586 0 59.3892 10.5693 59.3892 23.5607C59.3892 36.5521 48.7601 47.1215 35.6946 47.1215V47.123ZM35.6946 3.62036C24.6364 3.62036 15.6396 12.5665 15.6396 23.5622C15.6396 34.558 24.6364 43.5041 35.6946 43.5041C46.7528 43.5041 55.7497 34.558 55.7497 23.5622C55.7497 12.5665 46.7528 3.62036 35.6946 3.62036Z",
    fill: "#F8C92A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5973 15.889L32.7153 22.7363C33.6305 22.823 34.6371 22.8784 35.7248 22.8769C36.5079 22.8769 37.2475 22.8455 37.9436 22.7946C38.2917 22.7692 38.5092 22.4116 38.3757 22.0915C37.5056 20.024 36.6354 17.9565 35.7653 15.8875C35.7338 15.8142 35.6303 15.8142 35.6003 15.8875L35.5973 15.889Z",
    fill: "url(#paint2_linear_1403_13830)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6946 26.185C37.0673 26.185 38.179 25.0794 38.179 23.715C38.179 22.3507 37.0673 21.2451 35.6946 21.2451C34.3219 21.2451 33.2102 22.3507 33.2102 23.715C33.2102 25.0794 34.3219 26.185 35.6946 26.185Z",
    fill: "#721011"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1371 21.7699C37.519 21.0025 36.6099 20.603 35.6932 20.603C35.0076 20.603 34.3175 20.8259 33.7414 21.2852C32.3927 22.3579 32.1737 24.3161 33.2539 25.6566C33.872 26.424 34.7811 26.8235 35.6977 26.8235C36.3834 26.8235 37.0735 26.6006 37.6495 26.1413C38.9983 25.0671 39.2173 23.1103 38.1371 21.7699ZM36.8844 25.1898C36.5439 25.4606 36.1328 25.6042 35.6977 25.6042C35.1157 25.6042 34.5741 25.3454 34.211 24.8951C33.5554 24.0813 33.6889 22.8889 34.5081 22.2367C34.8486 21.9659 35.2597 21.8223 35.6947 21.8223C36.2768 21.8223 36.8184 22.0811 37.1815 22.5314C37.8371 23.3452 37.7036 24.5375 36.8844 25.1898Z",
    fill: "url(#paint3_linear_1403_13830)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5481 45.4038C36.4191 45.887 35.93 46.1713 35.4574 46.0396C34.9848 45.908 34.7058 45.4098 34.8363 44.9281C34.9653 44.4449 35.4544 44.1606 35.927 44.2923C36.3996 44.4239 36.6786 44.9206 36.5481 45.4038ZM35.927 1.10981C35.4544 0.97816 34.9653 1.2624 34.8363 1.74562C34.7073 2.22883 34.9863 2.72551 35.4574 2.85716C35.93 2.9888 36.4191 2.70456 36.5481 2.22135C36.6771 1.73814 36.3981 1.24146 35.927 1.10981ZM57.6443 22.7227C57.1597 22.5941 56.6587 22.8708 56.5266 23.3406C56.3946 23.8103 56.6812 24.2965 57.1657 24.4252C57.6503 24.5539 58.1514 24.2771 58.2834 23.8074C58.4154 23.3376 58.1289 22.8514 57.6443 22.7227ZM14.2187 22.7227C13.7341 22.5941 13.233 22.8708 13.101 23.3406C12.969 23.8103 13.2555 24.2965 13.7401 24.4252C14.2247 24.5539 14.7258 24.2771 14.8578 23.8074C14.9898 23.3376 14.7032 22.8514 14.2187 22.7227ZM51.4814 9.07759C51.9164 8.82775 52.0725 8.28021 51.8324 7.85385C51.5924 7.42898 51.0433 7.28686 50.6097 7.53669C50.1747 7.78653 50.0186 8.33407 50.2587 8.76043C50.4987 9.1853 51.0478 9.32742 51.4814 9.07759ZM50.5902 38.0599C50.1627 38.2992 50.0201 38.8438 50.2707 39.2761C50.5227 39.7085 51.0733 39.8641 51.5009 39.6247C51.9284 39.3854 52.071 38.8408 51.8204 38.4085C51.5699 37.9761 51.0178 37.8205 50.5902 38.0599ZM19.8835 7.52472C19.456 7.76409 19.3135 8.30863 19.564 8.74098C19.816 9.17333 20.3666 9.32892 20.7942 9.08955C21.2217 8.85019 21.3643 8.30564 21.1137 7.87329C20.8617 7.44095 20.3111 7.28536 19.8835 7.52472ZM19.903 38.0719C19.468 38.3217 19.312 38.8692 19.552 39.2956C19.792 39.7205 20.3411 39.8626 20.7747 39.6128C21.2097 39.3629 21.3658 38.8154 21.1257 38.389C20.8857 37.9641 20.3366 37.822 19.903 38.0719Z",
    fill: "#FDF7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_13830",
    x1: 35.8282,
    y1: 49.3563,
    x2: 35.8282,
    y2: 46.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#E1E1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#949285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#252111"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1403_13830",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.612 23.3152) scale(19.9053 19.8494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1403_13830",
    x1: 32.7153,
    y1: 19.3568,
    x2: 38.4147,
    y2: 19.3568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCB316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FBAA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FBAD18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FEBB1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FED940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEEB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FEF275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FEF275"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1403_13830",
    x1: 32.5668,
    y1: 23.7132,
    x2: 38.8227,
    y2: 23.7132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCB316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FBAA19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FBAD18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FEBB1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FED940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#FEEB5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FEF275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FEF275"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1403_13830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 71.2,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpin);
export default __webpack_public_path__ + "static/media/icon_spin.6cb4aab063255443ccde299469dc9364.svg";
export { ForwardRef as ReactComponent };